import cx from "classnames";
import React, { useContext } from "react";
import Icon from '../../common/components/Icon/Icon';
import { PageType } from "../enums/PageType";
import { IApplicantInfo } from "../interfaces/IAppFormData";
import { AppFormControllerContext } from "../providers/AppFormProvider";
import AFSidebarApplicantRow from "./AFSidebarApplicantRow";

interface ISideBarPageRowDetails {
    currentPage: PageType,
    page: PageType,
    text: string,
    currentClientNumber: number,
    applicants: IApplicantInfo[]
}

const AFSidebarPageRow: React.FC<ISideBarPageRowDetails> = (props) => {
    const { currentPage, page, text, currentClientNumber, applicants } = props;
    const isActive = currentPage == page;
    const hasApplicants = applicants.length > 0

    return (
        <div className={cx("layout-flex-column")}>
            <div className={cx("panel-sidebar-top-level",
                {
                    "panel-sidebar-active": isActive && !hasApplicants
                })}>
                <Icon
                    alt={currentPage > page ? "Tick" : "Pencil"}
                    className="space-s"
                    size="2xl"
                    id={currentPage > page ? "GreenTickNew" : "Pencil"}
                />
                <b className={cx({
                    "text-disabled": currentPage < page
                    })}>{text}</b>
            </div>
            {isActive && applicants.map((applicant) => {
                return <AFSidebarApplicantRow
                    key={applicant.clientNumber}
                    applicant={applicant}
                    currentClientNumber={currentClientNumber}
                />
            })}
        </div>
    );
};

export default AFSidebarPageRow;
